﻿import {
	FullEntityRelation,
	getResidencyConfiguration,
	InstallationByHostData, ParkingCategory,
	ResidencyId,
	ResidencyPropertyFlags,
	ResidencyResult,
	ResidencyUses
} from "@2d-front-monorepo/permits-business";

export default function getResidencyHiddenFields(installation: InstallationByHostData, residency: FullEntityRelation<ResidencyId, ResidencyResult> | undefined, category: ParkingCategory): ResidencyPropertyFlags {
	if (residency == null) {
		return Number.MAX_SAFE_INTEGER;
	}

	const entity = residency.original.entity;
	if (entity.uses === ResidencyUses.None) {
		// Placeholder entity: not yet in holders (read model lag after permit creation) or deleted
		return Number.MAX_SAFE_INTEGER;
	}
	return getResidencyConfiguration(installation, entity.uses, category).fieldRules.hidden;
}
